import { useMutation } from 'react-query';
import { BASE_URL } from '../../../constants/endpoints';
import { httpService } from '../../../services/http.service';
import { useStore } from '../../../store';

export interface PlaidTokenResponse {
  linkToken: {
    expiration: string;
    request_id: string;
    link_token: string;
  };
  customData: {
    depositSwitchId: string;
  };
}

export const usePlaidToken = () => {
  const { customerId } = useStore((state) => state.user);

  return useMutation(async (institutionId?: string) => {
    const { data } = await httpService.post<PlaidTokenResponse>(
      `${BASE_URL}/api/v1/user/${customerId}/linkToken/TRANSACTIONS`,
      institutionId ? { institutionId } : {},
    );
    return data;
  });
};
